import script from "./BackgroundDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BackgroundDialog.vue?vue&type=style&index=0&id=fdee2384&lang=css"

const __exports__ = script;

export default __exports__